export function storeToLocalStorage(key: string, value: string): void {
  localStorage.setItem(key, value);
}
